export default {
  title: '¡Factura Pendiente!',
  subtitle:
    'Tienes factura(s) pendiente(s) de pago. Te invitamos a realizar tu pago ingresando al siguiente link:',
  button: {
    default: 'Pagar aquí',
    mcapp: 'Regresar'
  }
}
